module.exports = __webpack_public_path__ + "static/img/carousel-banner-motorcycle-ms.7b37ddd.jpg";